// Чистые форматтеры метрик отчёта (ANX-068). Без зависимостей — легко тестятся.

// formatSecs — секунды → «м:сс»; null → «—».
export function formatSecs(secs: number | null | undefined): string {
  if (secs === null || secs === undefined) return '—';
  const total = Math.max(0, Math.round(secs));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

// formatDeltaPct — относительное изменение: «↑ 100%» / «↓ 20%» / «→ 0%»;
// null → "" (нет базы для сравнения).
export function formatDeltaPct(pct: number | null | undefined): string {
  if (pct === null || pct === undefined) return '';
  const v = Math.round(pct);
  if (v > 0) return `↑ ${v}%`;
  if (v < 0) return `↓ ${-v}%`;
  return '→ 0%';
}

// deltaTone — знак изменения для подсветки (положительное/отрицательное/нейтрально).
export function deltaTone(pct: number | null | undefined): 'up' | 'down' | 'flat' | 'none' {
  if (pct === null || pct === undefined) return 'none';
  if (pct > 0) return 'up';
  if (pct < 0) return 'down';
  return 'flat';
}

// formatCsat — «80% (8/10)»; при отсутствии оценок → «—».
export function formatCsat(
  scorePct: number | null | undefined,
  pos: number,
  neg: number,
): string {
  if (scorePct === null || scorePct === undefined) return '—';
  return `${Math.round(scorePct)}% (${pos}/${pos + neg})`;
}

// formatOpCsat — компактная доля «80%»; "" если оценок нет.
export function formatOpCsat(pos: number, neg: number): string {
  const total = pos + neg;
  if (total === 0) return '';
  return `${Math.round((pos / total) * 100)}%`;
}
